export default {
    activated() {
        const scrollTop = this.$route.meta.scrollTop;
        const $content = document.querySelector('#app');

        if ((scrollTop || scrollTop === 0) && $content) {
            $content.scrollTop = scrollTop;
        }
    }
};